<h1 matDialogTitle>{{ data.title }}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
    <form [formGroup]="produtoForm" (keydown.enter)="$event.preventDefault()">
      <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" class="form-container">
        <!-- Campo de Upload -->
        <div fxFlex="100">
          <mat-form-field class="full-width">
            <mat-label>Anexar Imagem/Foto
              <mat-icon ngxMatFileInputIcon>image</mat-icon>
            </mat-label>
            <ngx-mat-file-input
              name="file"
              [(ngModel)]="file"
              [ngModelOptions]="{ standalone: true }"
              [accept]="'image/*'"
            ></ngx-mat-file-input>
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-card>

  <!-- Galeria de Imagens -->
  <div class="images-gallery mat-box-shadow">
    <div fxLayout="row wrap" fxLayoutGap="16px">
      <div *ngFor="let photo of imagens$ | async; let i = index" fxFlex="100" fxFlex.gt-sm="25" fxFlex.sm="50">
        <mat-card class="user-card p-0">
          <mat-card-title>
            <div class="card-title-text">
              <h4 class="photo-detail fz-1" [fxHide.lt-sm]="true">{{"Foto " + (i + 1)}}</h4>
              <span fxFlex></span>
              <button mat-icon-button [matMenuTriggerFor]="userMenu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #userMenu="matMenu">
                <button mat-menu-item (click)="$event.preventDefault(); deleteImage(i)">
                  <mat-icon color="warn">delete</mat-icon> Delete
                </button>
              </mat-menu>
            </div>
            <mat-divider></mat-divider>
          </mat-card-title>
          <mat-card-content>
            <div class="user-details">
              <img
                [src]="getImageUrl(produto.id, i) | authimage | async"
                alt="Foto {{ i + 1 }}"
                *ngIf="showImages"
                class="gallery-image"
              />
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>

<mat-dialog-actions>
  <div fxFlex="100" class="action-buttons">
    <button
      mat-raised-button
      color="primary"
      (click)="$event.preventDefault(); saveImage()"
    >
      <mat-icon>save</mat-icon> {{ "SAVE" | translate }}
    </button>
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()">
      <mat-icon>close</mat-icon> {{ "CLOSE" | translate }}
    </button>
  </div>
</mat-dialog-actions>